import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ImageComponent = React.lazy(() => import("../Components/RootComponents/ImageComponent"));
const ImagePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ImageComponent />
      </Suspense>
    </Fragment>
  );
};

export default ImagePage;
